import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpResponse } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { AuthService } from './auth.service';
import { HttpErrorResponse } from '@angular/common/http/src/response';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class DocumentTypeService {

  public static readonly DOCUMENT_TYPE_CONTROLLER = environment.apiUrl + '/document';
  public static readonly URL_GET_ALL_DOC_TYES = DocumentTypeService.DOCUMENT_TYPE_CONTROLLER + "/all/types";

  constructor(private http: HttpClient, private authService: AuthService) { 

  }

  getAllDocumentTypes(documentType : DocumentType) : Observable<HttpResponse<DocumentType[]>>{
    const userToken = this.authService.getUserToken()
    const urlToCall = DocumentTypeService.URL_GET_ALL_DOC_TYES + "/" + userToken;
    return this.http.post<DocumentType[]>(urlToCall,documentType, {observe : 'response'})
      .pipe(catchError(this.handleError('Request Failed')));
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: HttpErrorResponse) => {
      if (error.status === 401) {
        localStorage.removeItem('currentUser');
        window.location.replace('');
      }
      return Observable.throw(error);
    };
  }

}
